import React from "react";

const GoodAt = ({ id }) => {
  return (
    <div id={id}>
      <section class="text-gray-400 bg-gray-900 body-font">
        <div class="container px-5 py-10 md:py-20 mx-auto">
          <div class="text-center mb-20">
            <h1 class="sm:text-3xl text-2xl font-medium title-font text-white mb-4">
              Here's what I'm good at.
            </h1>
            <p class="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text-gray-400 text-opacity-80">
              This is what I specialize in, but not limited to.
            </p>
            <div class="flex mt-6 justify-center">
              <div class="w-16 h-1 rounded-full bg-indigo-500 inline-flex"></div>
            </div>
          </div>
          <div class="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4 md:space-y-0 space-y-6">
            <div class="p-4 md:w-1/3 flex flex-col text-center items-center">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-gray-800 text-indigo-500 mb-5 flex-shrink-0">
                <img
                  className="h-8 w-8"
                  src="https://cdn-icons-png.flaticon.com/512/174/174854.png"
                />
              </div>
              <div class="flex-grow">
                <h2 class="text-white text-lg title-font font-medium mb-3">
                  Html5
                </h2>
                <p class="leading-relaxed text-base">
                  The standard markup language used to create web pages and
                  other web-based documents. It provides a structure for content
                  and enables developers to add text, images, videos, and other
                  media to their web pages.
                </p>
                {/* <a class='mt-3 text-indigo-400 inline-flex items-center'>
                  Learn More
                  <svg
                    fill='none'
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    class='w-4 h-4 ml-2'
                    viewBox='0 0 24 24'
                  >
                    <path d='M5 12h14M12 5l7 7-7 7'></path>
                  </svg>
                </a> */}
              </div>
            </div>
            <div class="p-4 md:w-1/3 flex flex-col text-center items-center">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-gray-800 text-indigo-400 mb-5 flex-shrink-0">
                <img
                  className="h-8 w-8"
                  src="https://cdn-icons-png.flaticon.com/512/732/732190.png"
                />
              </div>
              <div class="flex-grow">
                <h2 class="text-white text-lg title-font font-medium mb-3">
                  CSS3{" "}
                </h2>
                <p class="leading-relaxed text-base">
                  A stylesheet language used to describe the presentation of web
                  pages, including the layout, color, and typography. It allows
                  developers to create visually appealing and responsive designs
                  that adapt to different devices and screen sizes.
                </p>
                {/* <a class='mt-3 text-indigo-400 inline-flex items-center'>
                  Learn More
                  <svg
                    fill='none'
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    class='w-4 h-4 ml-2'
                    viewBox='0 0 24 24'
                  >
                    <path d='M5 12h14M12 5l7 7-7 7'></path>
                  </svg>
                </a> */}
              </div>
            </div>
            <div class="p-4 md:w-1/3 flex flex-col text-center items-center">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-gray-800 text-indigo-400 mb-5 flex-shrink-0">
                <img
                  className="h-8 w-8"
                  src="https://cdn-icons-png.flaticon.com/512/5968/5968292.png"
                />
              </div>
              <div class="flex-grow">
                <h2 class="text-white text-lg title-font font-medium mb-3">
                  Javascript
                </h2>
                <p class="leading-relaxed text-base">
                  A programming language that is widely used to create
                  interactive web applications. It enables developers to add
                  dynamic and responsive behavior to their web pages, including
                  animations, form validation, and other interactive features.
                </p>
                {/* <a class='mt-3 text-indigo-400 inline-flex items-center'>
                  Learn More
                  <svg
                    fill='none'
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    class='w-4 h-4 ml-2'
                    viewBox='0 0 24 24'
                  >
                    <path d='M5 12h14M12 5l7 7-7 7'></path>
                  </svg>
                </a> */}
              </div>
            </div>
            <div class="p-4 md:w-1/3 flex flex-col text-center items-center">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-gray-800 text-indigo-400 mb-5 flex-shrink-0">
                <img
                  className="h-8 w-8"
                  src="https://cdn-icons-png.flaticon.com/512/3459/3459528.png"
                />
              </div>
              <div class="flex-grow">
                <h2 class="text-white text-lg title-font font-medium mb-3">
                  React
                </h2>
                <p class="leading-relaxed text-base">
                  A popular JavaScript library used to build user interfaces
                  (UI) for web and mobile applications. It provides a
                  component-based approach to UI development and allows
                  developers to create reusable and modular UI components.
                </p>
                {/* <a class='mt-3 text-indigo-400 inline-flex items-center'>
                  Learn More
                  <svg
                    fill='none'
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    class='w-4 h-4 ml-2'
                    viewBox='0 0 24 24'
                  >
                    <path d='M5 12h14M12 5l7 7-7 7'></path>
                  </svg>
                </a> */}
              </div>
            </div>
            <div class="p-4 md:w-1/3 flex flex-col text-center items-center">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-gray-800 text-indigo-400 mb-5 flex-shrink-0">
                <img
                  className="h-8 w-8"
                  src="https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg"
                />
              </div>
              <div class="flex-grow">
                <h2 class="text-white text-lg title-font font-medium mb-3">
                  Redux
                </h2>
                <p class="leading-relaxed text-base">
                  A state management library used in conjunction with React or
                  other JavaScript frameworks to manage application state. It
                  provides a predictable and centralized way to manage data flow
                  and enables developers to write scalable and maintainable
                  code.
                </p>
                {/* <a class='mt-3 text-indigo-400 inline-flex items-center'>
                  Learn More
                  <svg
                    fill='none'
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    class='w-4 h-4 ml-2'
                    viewBox='0 0 24 24'
                  >
                    <path d='M5 12h14M12 5l7 7-7 7'></path>
                  </svg>
                </a> */}
              </div>
            </div>
            <div class="p-4 md:w-1/3 flex flex-col text-center items-center">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-gray-800 text-indigo-400 mb-5 flex-shrink-0">
                <img
                  className="h-8 w-8"
                  src="https://cdn-icons-png.flaticon.com/512/5968/5968322.png"
                />
              </div>
              <div class="flex-grow">
                <h2 class="text-white text-lg title-font font-medium mb-3">
                  Node js
                </h2>
                <p class="leading-relaxed text-base">
                  A server-side JavaScript runtime environment used to build
                  scalable and high-performance applications. It allows
                  developers to write JavaScript code outside of the browser and
                  provides access to a wide range of libraries and modules.
                </p>
                {/* <a class='mt-3 text-indigo-400 inline-flex items-center'>
                  Learn More
                  <svg
                    fill='none'
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    class='w-4 h-4 ml-2'
                    viewBox='0 0 24 24'
                  >
                    <path d='M5 12h14M12 5l7 7-7 7'></path>
                  </svg>
                </a> */}
              </div>
            </div>
            <div class="p-4 md:w-1/3 flex flex-col text-center items-center">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-gray-800 text-indigo-400 mb-5 flex-shrink-0">
                <img
                  className="h-8 w-8"
                  src="https://cdn-icons-png.flaticon.com/512/5968/5968381.png"
                />
              </div>
              <div class="flex-grow">
                <h2 class="text-white text-lg title-font font-medium mb-3">
                  Typescript
                </h2>
                <p class="leading-relaxed text-base">
                  A superset of JavaScript that adds optional static typing and
                  other features to the language. It helps developers catch
                  errors early in the development process and write more
                  maintainable and scalable code.
                </p>
                {/* <a class='mt-3 text-indigo-400 inline-flex items-center'>
                  Learn More
                  <svg
                    fill='none'
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    class='w-4 h-4 ml-2'
                    viewBox='0 0 24 24'
                  >
                    <path d='M5 12h14M12 5l7 7-7 7'></path>
                  </svg>
                </a> */}
              </div>
            </div>
            <div class="p-4 md:w-1/3 flex flex-col text-center items-center">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-gray-800 text-indigo-400 mb-5 flex-shrink-0">
                <img
                  className="h-8 w-8"
                  src="https://cdn-icons-png.flaticon.com/512/4494/4494748.png"
                />
              </div>
              <div class="flex-grow">
                <h2 class="text-white text-lg title-font font-medium mb-3">
                  Git
                </h2>
                <p class="leading-relaxed text-base">
                  A distributed version control system used to manage changes to
                  source code during software development. It allows multiple
                  developers to work on the same codebase simultaneously and
                  track changes made by each developer over time.
                </p>
                {/* <a class='mt-3 text-indigo-400 inline-flex items-center'>
                  Learn More
                  <svg
                    fill='none'
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    class='w-4 h-4 ml-2'
                    viewBox='0 0 24 24'
                  >
                    <path d='M5 12h14M12 5l7 7-7 7'></path>
                  </svg>
                </a> */}
              </div>
            </div>
            <div class="p-4 md:w-1/3 flex flex-col text-center items-center">
              <div class="w-20 h-20 inline-flex items-center justify-center rounded-full bg-gray-800 text-indigo-400 mb-5 flex-shrink-0">
                <img
                  className="h-4 w-8"
                  src="https://user-images.githubusercontent.com/3104648/28351989-7f68389e-6c4b-11e7-9bf2-e9fcd4977e7a.png"
                />
              </div>
              <div class="flex-grow">
                <h2 class="text-white text-lg title-font font-medium mb-3">
                  PWA
                </h2>
                <p class="leading-relaxed text-base">
                  Are web applications that provide a native app-like experience
                  to users. They are designed to work offline, be installable,
                  and provide features such as push notifications and home
                  screen access. PWAs are built using web technologies and offer
                  several advantages over traditional web apps.
                </p>
                {/* <a class='mt-3 text-indigo-400 inline-flex items-center'>
                  Learn More
                  <svg
                    fill='none'
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    class='w-4 h-4 ml-2'
                    viewBox='0 0 24 24'
                  >
                    <path d='M5 12h14M12 5l7 7-7 7'></path>
                  </svg>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GoodAt;
